import { Firestore, Functions } from "lib/firebase";

const generateEmailBody = (customer, resetLink) => {
    const generateEnglishEmail = () => {
        const messageParts = ['Hello,',
            `Follow this link to reset your Hack Your Closet password for your <i>${customer.email}</i> account.`,
            `<a href="${resetLink}" target="_blank">Click here</a> to reset password.`,
            'If you didn’t ask to reset your password, you can ignore this email.',
            'Thanks,<br/>Your Hack Your Closet team'];

        return messageParts.join('<br/><br/>');
    }

    const generateSwedishEmail = () => {
        const messageParts = ['Hej,',
            `Följ denna länk för att återställa ditt Hack Your Closet lösenord för din <i>${customer.email}</i> användare.`,
            `<a href="${resetLink}" target="_blank">Klicka här</a> för att återställa lösenordet.`,
            'Vänligen bortse från mejlet om du ej begärt att återställa ditt lösenord.',
            'Tack!<br/>Ditt Hack Your Closet team'];

        return messageParts.join('<br/><br/>');
    }

    const generateFrenchEmail = () => {
        const messageParts = ['Bonjour,',
            `Suivez sur ce lien pour réinitialiser le mot de passe de votre compte Hack Your Closet <i>${customer.email}</i> .`,
            `<a href="${resetLink}" target="_blank">Cliquez ici</a> pour réinitialiser le mot de passe.`,
            `Si vous n'avez pas demandé la réinitialisation de votre mot de passe, vous pouvez ignorer cet email.`,
            'Merci,<br/>Votre équipe Hack Your Closet'];

        return messageParts.join('<br/><br/>');
    }

    const { country } = customer;
    if (country === 'Sweden') {
        return generateSwedishEmail();
    }

    if (country === 'France') {
        return generateFrenchEmail();
    }

    return generateEnglishEmail();
}

const generateEmailSubject = (customer) => {
    const { country } = customer;

    if (country === 'Sweden') {
        return 'Återställ ditt lösenord för Hack Your Closet';
    }

    if (country === 'France') {
        return 'Réinitialisez votre mot de passe pour Hack Your Closet';
    }

    return 'Reset your password for Hack Your Closet';
}

const generateResetLink = async (customer) => {
    const { data } = await Functions.httpsCallable('tidieResetPassword')({ uid: customer.id, email: customer.email });
    return data.link;
}

export const sendResetPasswordEmail = async (customer) => {
    const resetLink = await generateResetLink(customer);

    await Firestore.collection('mail').doc(customer.id).delete();
    await Firestore.collection('mail')
        .doc(customer.id)
        .set({
            to: customer.email,
            message: {
                subject: generateEmailSubject(customer),
                html: generateEmailBody(customer, resetLink),
            },
        });
}

export const getPasswordResetEmail = async (customer) => {
    const data = await Firestore.collection('mail').doc(customer.id).get();
    return data.data();
}

export const setPassword = async (customer) => {
    const { data } =
        await Functions.httpsCallable('tidieSetPassword')({ uid: customer.id, email: customer.email });
    return data.password;
}

/**
 * Dynamically extracts the href from email body
 * @param {} email 
 * @returns string with reset link
 */
export const extractLastResetLinkFromEmail = (email) => {
    const start = email.indexOf('<a href');
    const end = email.indexOf('</a>') + '</a>'.length;

    const anchor = email.slice(start, end);

    const domP = new DOMParser();
    const document = domP.parseFromString(anchor, 'text/html');
    return document.getElementsByTagName('a')[0].href;
}
